// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__1uOym","footer":"ReportModalFilter_footer__VPb1p"};